import { render, staticRenderFns } from "./ValuesPickerModal.vue?vue&type=template&id=35072c7e&"
import script from "./ValuesPickerModal.vue?vue&type=script&lang=js&"
export * from "./ValuesPickerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports